// packages/web/src/components/Schedule/PublishScheduleBanner.tsx
import React from 'react';
import { Box, Typography, Button, Paper, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import SportsTennisIcon from '@mui/icons-material/SportsTennis';
import CloseIcon from '@mui/icons-material/Close';

const BannerContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(0.75, 1.5),
  borderRadius: '6px',
  backgroundColor: '#ffffff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1.5),
  border: '1.5px dashed #4caf50',
  position: 'relative',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    textAlign: 'center',
    padding: theme.spacing(0.75, 1),
  },
}));

const PublishButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#4caf50',
  color: 'white',
  padding: theme.spacing(0.75, 2),
  fontWeight: 600,
  textTransform: 'none',
  whiteSpace: 'nowrap',
  fontSize: '0.8rem',
  minHeight: '32px',
  '&:hover': {
    backgroundColor: '#45a049',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    padding: theme.spacing(0.5, 1.5),
    fontSize: '0.75rem',
    minHeight: '28px',
  },
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
  padding: 4,
  marginLeft: theme.spacing(1),
  '& .MuiSvgIcon-root': {
    fontSize: '1rem',
  },
}));

interface PublishScheduleBannerProps {
  onPublishClick: () => void;
  onClose: () => void;
}

export const PublishScheduleBanner: React.FC<PublishScheduleBannerProps> = ({ 
  onPublishClick,
  onClose,
}) => {
  return (
    <BannerContainer elevation={0}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <SportsTennisIcon sx={{ color: '#4caf50', fontSize: 24 }} />
        <Box>
          <Typography variant="body1" sx={{ fontWeight: 600, color: '#333', fontSize: '0.85rem', lineHeight: 1.2 }}>
            Help other players find you by publishing your schedule
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.7rem', lineHeight: 1.2 }}>
            Add your available time slots and let others challenge you
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <PublishButton
          variant="contained"
          size="small"
          onClick={onPublishClick}
        >
          PUBLISH MY TENNIS SCHEDULE
        </PublishButton>
        <CloseButton onClick={onClose} size="small" aria-label="Close banner">
          <CloseIcon />
        </CloseButton>
      </Box>
    </BannerContainer>
  );
};